function useFormatNumber() {
  const locale = 'et-EE';
  return (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat(locale, { ...options }).format(value);
}

export default useFormatNumber;
